import React from "react";
import axios from "axios";

// Shared by the public marketing-site forms (construction QuoteForm, key-service contact form).
// Backend: POST /api/public/contact (routes/contactRoutes.js).

export const HONEYPOT_FIELD = "website";

const hiddenStyle = {
  position: "absolute",
  left: "-10000px",
  top: "auto",
  width: "1px",
  height: "1px",
  overflow: "hidden"
};

/** Trap field for bots: invisible, skipped by keyboard and assistive tech. */
export const Honeypot = ({ value, onChange }) => (
  <div style={hiddenStyle} aria-hidden="true">
    <label>
      Website
      <input
        type="text"
        name={HONEYPOT_FIELD}
        tabIndex={-1}
        autoComplete="off"
        value={value}
        onChange={onChange}
      />
    </label>
  </div>
);

/**
 * Sends a submission. Resolves on success; rejects with an Error carrying `status` and
 * `fieldErrors`, where `fieldErrors` maps backend field names to (German) messages.
 */
export const submitContact = async payload => {
  try {
    await axios.post(`${process.env.REACT_APP_BACKEND_URL}/public/contact`, payload);
  } catch (error) {
    const status = error.response?.status;
    const data = error.response?.data || {};
    throw Object.assign(new Error(data.message || error.message), {
      status,
      fieldErrors: status === 400 && data.errors ? data.errors : {}
    });
  }
};
